import { useState } from 'react';
import Portal from "../../lib/customHooks/usePortal";
import { ClientInput } from "../inputs/ClientInput";
import { ClientPhotoUpload } from "../inputs/ClientPhotoUpload";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
export const PhotoPreview = props => {
  const {
    guid,
    value,
    label,
    required,
    errors,
    disabled = false,
    update,
    length = 0
  } = props;
  const hasValues = Boolean(value && value.length);
  const isMultiple = length !== null && length > 0;
  const hasMultiple = hasValues && value.length > 1;
  const [modalOpen, setModalOpenState] = useState(false);
  const [lastFocused, setLastFocused] = useState(() => document.activeElement);
  const limit = length === null || length < 0 ? 0 : length;
  const [hasTempFiles, setHasTempFiles] = useState(false);
  const openModal = () => {
    setModalOpenState(true);
    if (lastFocused) {
      // allow us to return to previous tab focus, despite blur
      setLastFocused(document.activeElement);
    }
    if (document.activeElement) {
      document.activeElement.blur();
    }
  };
  const onKeyPress = e => {
    e.preventDefault();
    openModal();
  };
  const closeModal = () => {
    setModalOpenState(false);
    if (lastFocused) {
      lastFocused.focus();
    }
  };
  const modalClassName = `portal-modal is-photo-upload ${isMultiple && hasTempFiles ? `is-multiple-photo` : `is-single-photo`}`;
  // this controls the input text, not the inner component
  const s = hasMultiple || isMultiple && !hasValues ? `s` : ``;
  return <div className="photo-upload--field">
      <ClientInput onClick={openModal} onKeyPress={onKeyPress} additionalClass={`tool-tip-event ${value && !errors ? 'completed' : 'incomplete'}`} placeholder={' '} readOnly inputMode="none" value={hasValues ? `${isMultiple ? `${value.length} ` : ''}Photo${s} Captured` : `Capture Photo${s}`} label={required ? `${label}*` : label} error={!!errors.length} errorText={errors} disabled={disabled} style={{
      caretColor: 'transparent'
    }} />
      {modalOpen && <Portal>
          <div className={modalClassName}>
            <div className="portal-modal--background" />
            <div className="portal-modal--modal-content">
              <button className="preview--close" onClick={closeModal}>
                <FontAwesomeIcon className="web-form-preview-close--btn" icon={faTimes} role="img" title="Close Web Form Preview" />
              </button>
              <ClientPhotoUpload guid={guid} closeModal={closeModal} savedImageUrl={value} isMultiple={isMultiple} limit={isMultiple ? limit : limit + 1} value={value} update={update} setHasTempFiles={setHasTempFiles} />
            </div>
          </div>
        </Portal>}
    </div>;
};